module.exports = __webpack_public_path__ + "fonts/Figtree-Black.d4a76ef.woff2";